<template>
	<el-card>
		<el-row :gutter="20">
			<el-col v-for="(item, index) in approvalList" :key="index" :span="6">
				<div class="approval-item" :style="approvalItemActive(index)" @click="handleApprovalSelect(index)" >
					<div style="font-size: 14px;">{{ item.title }}</div>
					<div style="color: #00000059;font-size: 12px;">{{ item.titleName }}</div>
				</div>
			</el-col>
		</el-row>
	</el-card>
</template>

<script>
import { mapActions } from 'vuex';
export default {
	name: 'flowDialog',

	props: {
		visible: {
			type: Boolean,
			default: false
		},
	},

	components:{},

	data () {
		return {
			way: '',
			selectIndex: '',
			approvalList: [],
			prodeuctArr:[
				{
					title: this.flowId == '1' ? "按产品所属品类审批" : "按产品所属售价表分类设置",
					id: 1,
					titleName: '选择售价表中相关产品所属的售价分类，设置流程。'
			  },
				{
					title: this.flowId == '1' ? "按店铺所属部门审批" : "按店铺所属部门设置",
					id: 2,
					titleName: '根据授权店铺档案中店铺直属上级所在的部门，即店铺所属的部门，选择部门，设置流程。'
			  },
				{
					title: this.flowId == '1' ? "按店铺所属平台审批" : "按店铺所属平台设置",
					id: 3,
					titleName: '选择店铺所在的平台，设置流程。'
				},
				{
					title: this.flowId == '1' ? "按店铺审批" : "按店铺设置",
					id: 4,
					titleName: '选择相关店铺，设置流程。'
				},
			],
			shopUrl: [
				{
					title: this.flowId == '1' ? "按店铺所属部门审批" : "按店铺所属部门设置",
					id: 2,
					titleName: '根据授权店铺档案中店铺直属上级所在的部门，即店铺所属的部门，选择部门，设置流程。'
			  },
				{
					title: this.flowId == '1' ? "按店铺所属平台审批" : "按店铺所属平台设置",
					id: 3,
					titleName: '选择店铺所在的平台，设置流程。'
				},
				{
					title: this.flowId == '1' ? "按店铺审批" : "按店铺设置",
					id: 4,
					titleName: '选择相关店铺，设置流程。'
				},
			],
		}
	},

	methods: {
		...mapActions([
			'reqSetApprovalWay'
		]),
		childFlow(data) {
			if (data) {
				if (data.index || data.index == 0) {
					this.selectIndex = data.index
				} else {
					this.selectIndex = ''
				}
				if (data.flowId) {
					this.flowId = data.flowId
				}
				if (data.approvalWay) {
					this.way = data.approvalWay
				}
				if (this.way == 'campaignproduct' || this.flowId == 2) {
					this.approvalList = this.prodeuctArr
				} else {
					this.approvalList = this.shopUrl
				}
			} else {
				this.selectIndex = ''
			}
		},
		// onClose() {
		// 	this.$emit('on-close')
		// },
		onApprovalSetting(index) {
			if (this.way == 'campaignlink' || this.way == 'campaignshop') {
				this.selectIndex = index + 1
			}
			const params = {
				approvalmethed: this.selectIndex + 1,
				approvaltype: this.flowId == '1' ? "CAM" : "REP",
				processmodel: '0'
			}
			if(this.flowId == '1') {
				if (this.way == 'campaignproduct') {
					params.declaremeans = '0'
				} else if (this.way == 'campaignlink') {
					params.declaremeans = '1'
				} else {
					params.declaremeans = '2'
				}
			}

			this.reqSetApprovalWay(params).then(res => {
        if(res.status == '10000') {
					const id = this.flowId == '2' ? '1' : this.way == 'campaignproduct' ? '2' : this.way == 'campaignlink' ? '3' : '4';
					this.$emit('on-close',id)
					this.selectIndex = id
					this.$message({
	          message: '设置成功',
	          type: 'success'
	        });
        } else {
					if (res.status == '11002') {
						this.$emit('flowDel','true')
						this.approvalItemActive(index)
					}
				}
      })
		},
		onDialogOpen() {
			if(this.flowId == '2') {
				this.approvalList = [
					{ title: "按产品所属品类处理", id: 1 },
					{ title: "按店铺所属部门处理", id: 2, },
					{ title: "按店铺所属平台处理", id: 3, },
					{ title: "按店铺处理", id: 4, },
				]
			}else {
				if(this.way == 'campaignproduct') {
					this.approvalList = [
						{ title: "按产品所属品类审批", id: 1 },
						{ title: "按店铺所属部门审批", id: 2, },
						{ title: "按店铺所属平台审批", id: 3, },
						{ title: "按店铺审批", id: 4, },
					]
				}else {
					this.approvalList = [
						{ title: "按店铺所属部门审批", id: 1, },
						{ title: "按店铺所属平台审批", id: 2, },
						{ title: "按店铺审批", id: 3, },
					]
				}
			}
		},
		handleApprovalSelect(index) {
			this.selectIndex = index;
			this.onApprovalSetting(index)
		},
		approvalItemActive(index) {
			return this.selectIndex === index ? {
				'color': '#1C9EFB',
				'boxShadow': '0px 3px 7px 0px rgba(0, 0, 0, 0.1)',
				'border': '1px solid #1C9EFB'
			} : {};
		},
	},

	computed: {},

	mounted(){
	}
}
</script>

<style lang="scss">
.newSet {
	border: 1px solid #999;
	border-radius: 10px;
	height: 100px;
	padding: 20px;
}
@mixin approval-item-active {
	color: #1C9EFB;
	box-shadow: 0px 3px 7px 0px
	rgba(0, 0, 0, 0.1);
	border: 1px solid #1C9EFB;
}

.approval-item {
	border: 1px solid #999;
	border-radius: 10px;
	min-height: 60px;
	color: #666666;
	font-size: 18px;
	cursor: pointer;
	padding: 20px;
}

.approval-item:hover{
	@include approval-item-active;
}

.approval-title {
	color: rgb(87, 86, 86);
	font-size: 18px;
}

// .g-center {
// 	display: flex;
// 	justify-content: center;
// 	align-items: center;
// }

.g-confirm-btn {
	background-color: #bda571;
	border: 0;
	color: #fff;
	&:hover {
		background-color: #bda571;
		color: #fff;
	}
}

.g-cancel-btn {
	&:hover {
		background-color: #F7EFE5;
		border: 1px solid #bda571;
		color: #4A4B4C;
	}
}
</style>
